import { IConnectionData, IDataSourceEntity, IDataSourceMapping } from "@gtmhub/insights";
import { ILookerConnectionData, isLookerBlueprint, LookerInsightSelectorService } from "@gtmhub/looker";
import { IComponentOptions, IPromise } from "angular";

export class DatasourceListItemCtrl {
  static $inject = ["LookerInsightSelectorService"];

  public item: IDataSourceMapping;
  public filterquery: string;
  public showEntities: boolean;
  public onDatasourceSelected: (arg: { entity: IDataSourceEntity }) => void;

  public constructor(private lookerInsightSelectorService: LookerInsightSelectorService) {}

  public $onInit(): void {
    this.showEntities = this.item.showEntities;
  }

  public selectItem(entity: IDataSourceEntity): void {
    this.onDatasourceSelected({ entity });
  }

  public toggleShowEntities(): IPromise<void> | void {
    if (!isLookerBlueprint(this.item.dataSource)) {
      return this.toggle();
    }

    const lookerConnections: ILookerConnectionData[] = this.item.connections.reduce((aggregator: ILookerConnectionData[], connection: IConnectionData) => {
      if (connection.id) {
        aggregator.push({ id: connection.id, name: connection.name });
      }
      return aggregator;
    }, []);

    if (lookerConnections.length === 0) {
      return this.toggle();
    }

    return this.lookerInsightSelectorService
      .openBuildInsightModal({
        connections: lookerConnections,
        blueprintName: this.item.dataSource,
      })
      .then((entity?: IDataSourceEntity): void => {
        if (entity) {
          this.onDatasourceSelected({ entity });
        }
      });
  }

  private toggle(): void {
    this.showEntities = !this.showEntities;
  }
}

export const DatasourceListItemComponent: IComponentOptions = {
  controller: DatasourceListItemCtrl,
  templateUrl: require("./datasource-list-item.jade"),
  bindings: {
    item: "<",
    filterquery: "@",
    onDatasourceSelected: "&",
  },
};
